import type { ThemeColors, DensityValues, Density } from '../types';

export const BRAND = '#b5297a';
export const BRAND_LIGHT = '#fce7f4';
export const BRAND_25 = '#fdf2f8';
export const BRAND_DARK = '#981f65';
export const SLATE = '#2d3c4e';

export function getThemeColors(dark: boolean): ThemeColors {
  if (dark) {
    return {
      bg: '#0b101a',
      card: '#141b27',
      cardMuted: '#0f1520',
      border: '#1e2735',
      borderSoft: '#1a222e',
      heading: '#f2f4f7',
      text: '#cfd7e3',
      muted: '#8392a7',
      placeholder: '#5a6a80',
      hover: '#1a2230',
      active: '#2a1222',
      chipBg: '#1a222e',
      tableHeader: '#0f1520',
      inputBg: '#0f1520',
    };
  }
  return {
    bg: '#f9fafb',
    card: '#ffffff',
    cardMuted: '#f9fafb',
    border: '#e4e7ec',
    borderSoft: '#f2f4f7',
    heading: '#101828',
    text: '#344054',
    muted: '#667085',
    placeholder: '#98a2b3',
    hover: '#f9fafb',
    active: '#fce7f4',
    chipBg: '#f2f4f7',
    tableHeader: '#f9fafb',
    inputBg: '#ffffff',
  };
}

export const DENSITY_VALUES: Record<Density, DensityValues> = {
  comfortable: { rowY: 12, cellX: 16, cardPad: 20, gap: 16 },
  compact:     { rowY: 7,  cellX: 12, cardPad: 14, gap: 10 },
};
